import React, { ReactNode } from 'react'
import { usePageContent, UseContentResponse, useGlobalContent } from '../hooks/useContent'
import PageSeo from './PageSeo'
import { Spinner } from 'components'
import Loader from 'components/atoms/Spinner/Loader'

type PageContentProps = {
    path: string
    children?:
        | ReactNode
        | (({
              data,
              loading,
              error
          }: {
              data
              loading?: UseContentResponse['loading']
              error?: UseContentResponse['error']
          }) => ReactNode)
}

export const withContent =
    <T extends React.FunctionComponent<any>>(path: string, Component: T) =>
    (props) => <PageContent path={path}>{({ data }) => <Component {...props} content={data} />}</PageContent>

export const withGlobalContent =
    <T extends React.FunctionComponent<any>>(path: string, Component: T) =>
    (props) => {
        const { content, loading, error } = useGlobalContent(path)

        if (error) {
            return <div>{error.message}</div>
        }

        if (loading) {
            return <Loader />
        }

        return <Component {...props} content={content} />
    }

export default function PageContent(props: PageContentProps) {
    const { children, path } = props
    const { content, loading, error } = usePageContent(path)

    if (error) {
        return <div>{error.message}</div>
    }

    return (
        <>
            {!loading && content?.seo && <PageSeo {...content?.seo} />}
            {typeof children === 'function' ? (
                loading ? (
                    <div className='flex min-h-[500px] w-full items-center justify-center'>
                        <Spinner />
                    </div>
                ) : (
                    <>{children({ data: content?.data })}</>
                )
            ) : (
                children
            )}
        </>
    )
}
